import { render, staticRenderFns } from "./MassCampaigns.vue?vue&type=template&id=030eb1d0&scoped=true&"
import script from "./MassCampaigns.vue?vue&type=script&lang=js&"
export * from "./MassCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./MassCampaigns.vue?vue&type=style&index=0&id=030eb1d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030eb1d0",
  null
  
)

export default component.exports